import {Autocomplete, TextField} from "@mui/material";

const MyComboBox = (props) => {

  const {options, label, id, readOnly, defaultValue, setter, value, filterOptions, size, style, classname, disabled, sx} = props;

  return (<Autocomplete
    disablePortal
    id={id}
    readOnly={readOnly === true}
    options={options}
    defaultValue={defaultValue ? defaultValue : null}
    onChange = {setter ? (event, newValue) =>{setter(newValue)} : null}
    sx={{...sx, width: 300}}
    renderInput={(params) => <TextField {...params} label={label}/>}
    value={value}
    filterOptions={filterOptions}
    size={size}
    style={style}
    disabled={disabled}
  />);
}

export default MyComboBox;
